export const userReducerConstant = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  GET_FOLLOWERS: "GET_FOLLOWERS",
  GET_FOLLOWINGS: "GET_FOLLOWINGS",
  GET_FOLLOWERS_SUGGESTION: "GET_FOLLOWERS_SUGGESTION",
  SET_FOLLOWERSFOLLOWINGS_COUNT: "SET_FOLLOWERSFOLLOWINGS_COUNT",
  SET_IMAGE_POSTS: "SET_IMAGE_POSTS",
  SET_USER_ACTIVITY_COUNT: "SET_USER_ACTIVITY_COUNT",
  GET_REELS: "GET_REELS",
};

export const utilReducerConstant = {
  SET_COUNTRY_LIST: "SET_COUNTRY_LIST",
  SET_STATE_LIST: "SET_STATE_LIST",
  SET_LANGUAGE_LIST: "SET_LANGUAGE_LIST",
  SET_CATEGORY_LIST: "SET_CATEGORY_LIST",
};

export const calendarReducerConstant = {
  SET_TIMEZONE_LIST: "SET_TIMEZONE_LIST",
  SET_CALENDARSCHEDULE_INFO: "SET_CALENDARSCHEDULE_INFO",
};

export const notificationReducerConstant = {
  GET_ACTIVE_COUNT: "GET_ACTIVE_COUNT",
  GET_NOTIFICATION_LIST: "GET_NOTIFICATION_LIST",
};

export const chatReducerConstant = {
  GET_ACTIVE_CHAT_COUNT: "GET_ACTIVE_CHAT_COUNT",
};

export const filterReducerConstant = {
  GET_FILTER_LIST: "GET_FILTER_LIST",
  UPDATE_FILTER_LIST: "UPDATE_FILTER_LIST",
  RESET_FILTER_LIST: "RESET_FILTER_LIST",
  // UPDATE_FILTER_CATEGORIES: "UPDATE_FILTER_CATEGORIES",
  // UPDATE_SINGLE: "UPDATE_SINGLE",
  // UPDATE_SINGLE_START: "UPDATE_SINGLE_START",
  // UPDATE_SINGLE_END: "UPDATE_SINGLE_END",
  // UPDATE_WEEKLY: "UPDATE_WEEKLY",
  // UPDATE_WEEKLY_START: "UPDATE_WEEKLY_START",
  // UPDATE_WEEKLY_END: "UPDATE_WEEKLY_END",
  // UPDATE_MONTHLY: "UPDATE_MONTHLY",
  // UPDATE_MONTHLY_START: "UPDATE_MONTHLY_START",
  // UPDATE_MONTHLY_END: "UPDATE_MONTHLY_END",
  // UPDATE_FILTER_STATE: "UPDATE_FILTER_STATE",
};
